module.exports = __webpack_public_path__ + "static/media/pratnadeep-banik.2c925eea.jpeg";